module.exports = __webpack_public_path__ + "static/media/p-logo.94a37c96.png";